module.exports = __webpack_public_path__ + "media/images/flags/AO-af8095ad4c5af434ec125c2ade100163.svg";